<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <img
            src="../assets/images/logo/logo_despacho.png"
            alt="logo"
            width="310"
          />
        </b-link>

        <b-card-title class="mb-1 centered"
          >Módulo Prontidão Hospitalar
        </b-card-title>
        <b-card-text class="mb-2">
          Por favor, forneca suas credenciais para acessar a plataforma.
        </b-card-text>

        <!-- form -->
        <validation-observer ref="loginForm" #default="{ invalid }">
          <b-form class="auth-login-form mt-2" @submit.prevent>
            <!-- email -->
            <b-form-group label-for="email" label="Login">
              <validation-provider
                #default="{ errors }"
                name="Login"
                rules="required"
              >
                <b-form-input
                  id="login"
                  v-model="email"
                  name="login-email"
                  :state="errors.length > 0 ? false : null"
                  placeholder="john.doe"
                  autofocus
                />
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">Senha</label>
                <b-link :to="{ name: 'auth-forgot-password-v1' }">
                  <small>Esqueceu sua senha?</small>
                </b-link>
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="login-password"
                    placeholder="Password"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
              >
                Lembre dos meus dados
              </b-form-checkbox>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
              @click="login"
            >
              Entrar
            </b-button>
          </b-form>
        </validation-observer>

        <!-- suporte técnico link -->
        <div class="text-center mt-2">
          <b-link
            class="text"
            style="font-size: 0.9rem; text-decoration: underline"
            @click="showSupport = true"
          >
            <feather-icon icon="LifeBuoyIcon" size="14" class="mr-25" />
            Suporte Técnico
          </b-link>
        </div>

        <b-card-text class="mt-2 centered" v-if="version">
          Versão: {{ version }}
        </b-card-text>

        <!-- Modal Suporte Técnico -->
        <b-modal
          id="modal-support"
          v-model="showSupport"
          title="Suporte 24 Horas IT4D"
          hide-footer
        >
          <div>
            <div class="mb-3">
              Atendimento 24 horas, incluindo sábados, domingos e feriados.<br />
              <span
                >(21) 96598-4853
                <b-link href="https://wa.me/5521965984853" target="_blank">
                  <i class="fab fa-whatsapp text-success"></i>
                </b-link>
              </span>
            </div>
            <div class="text-right">
              <b-button variant="secondary" @click="showSupport = false"
                >Fechar</b-button
              >
            </div>
          </div>
        </b-modal>
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: "",
      password: "",
      status: "",
      // validation rules
      required,
      email,
      passwordFieldType: "password",
      showSupport: false,
      version: "",
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  mounted() {
    this.getVersion();
  },
  methods: {
    async getVersion() {
      try {
        const response = await axios.get(this.$store.state.api + "version/");
        if (response && response.data) {
          this.version = response.data.code;
        }
      } catch (error) {
        console.error("Erro ao obter versão:", error);
      }
    },
    login() {
      const self = this;
      const api = this.$store.state.api + "login";
      self.$loading(true);
      axios
        .post(api, {
          login: self.email,
          password: self.password,
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);

          // Reconectar WebSocket com o novo token
          if (window.Echo) {
            window.Echo.disconnect();
            window.Echo.options.auth.headers.Authorization =
              "Bearer " + response.data.access_token;
            window.Echo.connect();
          }

          if (response.data.access_nivel == 20) {
            self.$router.push({ path: "/condutor/index" });
          } else {
            self.$router.push({ path: "/" });
          }
          self.$loading(false);
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
          self.$loading(false);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

// Centraliza o modal verticalmente na tela
.modal-support-center {
  min-height: 250px;
}

.modal-dialog {
  display: flex !important;
  align-items: center;
  min-height: 100vh;
}
</style>
